module.exports = __webpack_public_path__ + "static/media/DWFuturaLatinExtA.2a2cd884.woff2";